/**
 * @generated SignedSource<<9252a1e1f0aaf082c3eac1a9b2db3ddc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilters_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenuDrawerAppliedFilterDisplay_user" | "SbRespRefineMenuFilterPrice_user" | "SbRespRefineMenuFilterDimensions_user" | "SbMobileRefineMenuFilterPrice_user" | "SbMobileRefineMenuFilterDimensions_user" | "SbMobileRefineMenuFilterArtSize_user" | "SbRespRefineMenuFilterArtSize_user" | "useMeasurementUnit_user">;
  readonly " $fragmentType": "SbSharedRefineMenuFilters_user";
};
export type SbSharedRefineMenuFilters_user$key = {
  readonly " $data"?: SbSharedRefineMenuFilters_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuFilters_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFilters_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuDrawerAppliedFilterDisplay_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterPrice_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDimensions_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterPrice_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterDimensions_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterArtSize_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterArtSize_user"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeasurementUnit_user",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserPreferences",
          "kind": "LinkedField",
          "name": "preferences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "measurementUnit",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "ae97cd1dd15e5bf2ecc79cb29996ae6f";

export default node;
